<template>
    <div class="flex items-center">
        <div v-text="display"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: false,
            default() {
                return null;
            }
        },

        option: {
            type: Object,
            required: true,
        },
    },

    computed: {
        display() {
            if (! this.custom) {
                return this.option.display;
            }

            let value = this.value;

            try {
                value = Number(this.$route.query['filter[quantity]']);
            } catch (e) { /** do nothing */ }

            return 'Over ' + Number(value).toLocaleString();
        },

        custom() {
            return 'custom' === this.option.slug;
        },
    },
};
</script>

